<template>
	<section>
		<div class="modal fade" id="modalChooseTrip" tabindex="-1" role="dialog" aria-labelledby="modalChooseTripTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content mx-auto">
					<div class="modal-header">
						<h6 class="modal-title mx-auto" id="modalChooseTripTitle"> <strong>Pilih jenis shipment</strong>
						</h6>
					</div>
					<div class="modal-body">
						<div class="row mb-2">
							<button id="loose" class="col btn active mr-2" @click="popup = 'kg'">
								<img src="img/group.png" alt="">
								<br>
								<br>Kg</button>
							<button id="full" class="col btn" @click="popup = 'box'">
								<img src="img/group-44.png" alt="">
								<br>
								<br>Box</button>
						</div>
						<p :class="popup == 'kg' ? 'popup-left' : 'popup-right'">
							{{ 
								popup == 'kg' ? 
								'Per-Kg berarti perhitungan harga berdasarkan berat barang' : 
								'Per-Box berarti perhitungan harga berdasarkan banyaknya barang'
							}}
						</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="w-full pd-10-20 btn btn-secondary" data-dismiss="modal">Kembali</button> 
						<router-link :to="'/shipment/add/'+ popup" class="w-full pd-10-20 btn btn-primary" data-dismiss="modal">
							Selanjutnya
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'Modal',
	data() {
		return {
			popup: 'kg'
		}
	},	
	mounted(){
		var loose = '#loose';
		var full = '#full';

		$(loose).on('click', function(){
			$(full).removeClass('active');
			$(loose).addClass('active');			
		});

		$(full).on('click', function(){
			$(loose).removeClass('active');
			$(full).addClass('active');
		});
	}
}
</script>